<div class="cellWrapper">
    {{ $any(data).enabled ? ('generalKeywords.yes' | translate) : ('generalKeywords.no' | translate) }}
</div>
